<template lang="pug">
  .accordion-section(:class='{ open: opened }')
    button.question-wrap.clickable.btn-reset.full-width.text-left(@click='click')
      span.question.color-purple.bold.xs-f-small.md-f-medium.lg-f-xmedium.max-at-tweak
        | {{ question }}
        span.plus.mr-icon(v-if="showPlus" aria-label="expand") &#x002B;
        span.less.mr-icon(v-if="showMinus" aria-label="collapse") &ndash;
        span.caret(v-if="!usePlusMinusIcons")
        span.ada-tooltip accordion section {{ opened ? &apos;open&apos; : &apos;closed&apos; }}

    .answer-wrap.expand(:class='{ expanded: !opened }' transition='expand')
      p.answer.xs-f-small.md-f-medium.lg-f-medium.max-at-tweak(v-html='answer')

</template>

<script>
  export default {
    name: 'AccordionSection',

    props: {
      question: {
        type: String,
        default: '',
      },

      trackEventName: {
        type: String,
        default: 'Accordion Section Clicked',
      },

      answer: {
        type: String,
        default: '',
      },
      selected: {
        type: [Number],
        default: undefined,
        required: false,
      },

      usePlusMinusIcons: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      id: Math.floor(Math.random() * 10000),
    }),

    computed: {
      opened() {
        return this.id === this.selected;
      },

      showPlus() {
        return this.usePlusMinusIcons && !this.opened;
      },

      showMinus() {
        return this.usePlusMinusIcons && this.opened;
      }
    },

    methods: {
      click() {
        this.trackMREvent(this.trackEventName, { question: this.question });
        this.$emit('select', this.id);
      },
    },
  };
</script>

<style scoped lang="stylus">
  .expand
    max-height auto
    transition all 3s ease-in-out
  .expand.expanded
    max-height 0px
</style>
